import styled from 'styled-components';

const LayoutWrapper = styled.div`
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #fff;
`;
export default LayoutWrapper;